import React from "react";

/**
 * Shared chrome for Terms / Privacy / Refund pages.
 * Keeps typography, spacing, and the eyebrow / last-updated block consistent.
 */
export default function LegalPage({ testId, eyebrow = "Legal", title, lastUpdated, children }) {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16 lg:py-24" data-testid={testId}>
      <div className="overline"><span className="accent-line" /> {eyebrow}</div>
      <h1 className="font-display text-4xl lg:text-5xl mt-4 leading-tight">{title}</h1>
      {lastUpdated && (
        <p className="text-xs uppercase tracking-widest text-muted-foreground mt-3">
          Last updated · {lastUpdated}
        </p>
      )}

      <div className="prose-bp mt-10">
        {children}
      </div>
    </div>
  );
}
